import { Component, OnInit } from '@angular/core';
import { AppConfigService } from '@services/app-config.service';
import { SupportConfig } from '@interfaces/support-config';
import { AuthService } from '@services/auth.service';
import { UserService } from '@services/user.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
    support: SupportConfig;

    isAuth                : boolean = false;
    canSubscribeNewsletter: boolean = false;
    isSubscribedNewsletter: boolean = false;

    constructor(
        private configSrv: AppConfigService,
        private authSrv: AuthService,
        private userSrv: UserService
    ) {}

    ngOnInit() {
        this.isAuth = this.authSrv.isAuth();
        if (this.isAuth)
        {
            this.userSrv.isSubscribedNewsletter().subscribe(isSubscribedNewsletter =>
            {
                this.canSubscribeNewsletter = true;
                this.isSubscribedNewsletter = isSubscribedNewsletter;
            });
        }

        this.support = this.configSrv.support;
    }

    isSubscribedNewsletterChanged(event: MatCheckboxChange) {
        if (this.canSubscribeNewsletter)
            this.userSrv.setSubscribedNewsletter(event.checked);
    }
}
